import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'sm-dac-table',
  standalone: true,
  imports: [CommonModule, TableModule],
  template: `
    <p-table [value]="rows" [scrollable]="true" scrollHeight="400px" styleClass="w-full border rounded-lg">
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let h of headers">
            {{ h }}
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr>
          <td *ngFor="let key of columns">
            {{ row[key] ?? '' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  `,
})
export class TableDisplayComponent {
  @Input() rows: Record<string, any>[] = [];
  @Input() columns: string[] = [];
  @Input() headers: string[] = [];
}
